import { P, Spacing, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormSection } from 'omni-package-react-core';
import Address from '../../../../components/_Address';
import { PersonalInformation } from '../../../../interfaces/PersonalInformation';
import { StyledAddress, StyledAddressDiv, StyledSectionTitle } from './EditAddressSection.styles';
import AddressFormSection from './AddressFormSection';
import CountriesLoader from './CountriesLoader';
import { Option } from '../../../../interfaces/Option';
import ProvincesLoader from './ProvincesLoader';

export interface EditAddressSectionProps { personalInfo: PersonalInformation }

const EditAddressSection: FC<EditAddressSectionProps> = ({ personalInfo }) => {
  const { t } = useTranslation('PersonalInformationsFormPage');
  const countries: Option[] = useScopedSelector('/App.features.personalInformation.countries');
  const provinces: Option[] = useScopedSelector('/App.features.personalInformation.provinces');

  return (
    <>
      {personalInfo?.newAddress?.countryIso2 && <ProvincesLoader url={personalInfo?.newAddress?.countryIso2} />}
      <CountriesLoader>
        <FormSection pb={36} title={t('address.title')}>
          <StyledAddressDiv>
            <StyledAddress><Address personalInfo={personalInfo} isEditingAddress /></StyledAddress>
          </StyledAddressDiv>
          <Spacing m-b={12}>
            <StyledSectionTitle><P id="addressLabel">{t('address.newAdressLabel')}</P></StyledSectionTitle>
          </Spacing>
          <AddressFormSection
            personalInfo={personalInfo}
            countries={countries}
            provinces={provinces}
          />
        </FormSection>
      </CountriesLoader>
    </>
  );
};

export default EditAddressSection;
